import { logError } from "./logger";

class EditorError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'EditorError';
    logError('[EditorError] ', message);
  }
}

export default EditorError;
